/**
 * @generated SignedSource<<2d68737af6a0708c6fea9a422e8a1170>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type GoToPreviousElementInput = {
  clientMutationId?: string | null;
  contentSubmissionId: string;
};
export type ProjectContentElementContainer_GoBackElementWiseMutation$variables = {
  input: GoToPreviousElementInput;
};
export type ProjectContentElementContainer_GoBackElementWiseMutation$data = {
  readonly ELearning: {
    readonly goToPreviousElement: {
      readonly contentSubmission: {
        readonly " $fragmentSpreads": FragmentRefs<"ContentSubmissionScreen_ContentSubmissionFragment">;
      };
    } | null;
  };
};
export type ProjectContentElementContainer_GoBackElementWiseMutation = {
  response: ProjectContentElementContainer_GoBackElementWiseMutation$data;
  variables: ProjectContentElementContainer_GoBackElementWiseMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "shortDescription",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v8 = [
  (v7/*: any*/),
  (v2/*: any*/)
],
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "pacPoints",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "pharmaPoints",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstLearnOpportunityIdWithMultipleChoiceElement",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "concreteType": "WordpressCertificateAndLearnState",
  "kind": "LinkedField",
  "name": "wordpressCertificates",
  "plural": true,
  "selections": [
    (v2/*: any*/)
  ],
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "kind",
  "storageKey": null
},
v14 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "reasonConfigTypes",
    "storageKey": null
  }
],
v15 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "viewerTreeState",
  "plural": false,
  "selections": [
    (v4/*: any*/),
    (v13/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": (v14/*: any*/),
      "type": "CanNotBeStartedViewerTreeState",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "headContentId",
          "storageKey": null
        }
      ],
      "type": "IsStartedViewerTreeState",
      "abstractKey": null
    }
  ],
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "definitionType",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "containedElementTypes",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "headFirstElementType",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "extension",
  "plural": false,
  "selections": [
    (v4/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        (v9/*: any*/),
        (v10/*: any*/),
        (v19/*: any*/)
      ],
      "type": "LearnContentExtensionImpl",
      "abstractKey": null
    }
  ],
  "storageKey": null
},
v21 = {
  "kind": "InlineFragment",
  "selections": (v14/*: any*/),
  "type": "CanNotBeStartedContentNodeAdvancementResult",
  "abstractKey": null
},
v22 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "activeContentSubmissionId",
      "storageKey": null
    }
  ],
  "type": "ContinueContentNodeAdvancementResult",
  "abstractKey": null
},
v23 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "configResults",
      "plural": true,
      "selections": [
        (v4/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "configType",
          "storageKey": null
        },
        {
          "kind": "TypeDiscriminator",
          "abstractKey": "__isRestartIfFailedContentConfigResult"
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "canBeRestarted",
          "storageKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "blockedUntil",
              "storageKey": null
            }
          ],
          "type": "NegativeBlockTemporarilyRestartIfFailedContentConfigResult",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "CanNotBeRestartedAfterFailedContentNodeAdvancementResult",
  "abstractKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "concreteType": "LearnOpportunityV2",
  "kind": "LinkedField",
  "name": "root",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "structureDefinition",
      "plural": false,
      "selections": [
        (v4/*: any*/),
        (v5/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "extension",
              "plural": false,
              "selections": [
                (v4/*: any*/),
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v12/*: any*/)
                  ],
                  "type": "LearnOpportunityRootExtensionImpl",
                  "abstractKey": null
                }
              ],
              "storageKey": null
            },
            (v15/*: any*/)
          ],
          "type": "LearnOpportunityRootStructureDefinition",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "structureDefinition",
  "plural": false,
  "selections": [
    (v4/*: any*/),
    (v5/*: any*/)
  ],
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "concreteType": "File",
  "kind": "LinkedField",
  "name": "file",
  "plural": false,
  "selections": (v8/*: any*/),
  "storageKey": null
},
v27 = [
  (v26/*: any*/)
],
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "numElements",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "concreteType": "ELearningContentSubmissionRelativeProgress",
  "kind": "LinkedField",
  "name": "relativeProgress",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "numCorrect",
      "storageKey": null
    },
    (v29/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "percentageCorrect",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v31 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "amount",
    "storageKey": null
  }
],
v32 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "certificateName",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "IssuedCertificateV2",
    "kind": "LinkedField",
    "name": "issuedCertificate",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "File",
        "kind": "LinkedField",
        "name": "fileRef",
        "plural": false,
        "selections": (v8/*: any*/),
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "text",
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "question",
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "concreteType": "File",
  "kind": "LinkedField",
  "name": "image",
  "plural": false,
  "selections": (v8/*: any*/),
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "concreteType": "AnswerOptionWithoutCorrect",
  "kind": "LinkedField",
  "name": "answerOptions",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "answer",
      "storageKey": null
    },
    (v35/*: any*/)
  ],
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "answeringType",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ProjectContentElementContainer_GoBackElementWiseMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ELearningMutations",
        "kind": "LinkedField",
        "name": "ELearning",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "GoToPreviousElementPayload",
            "kind": "LinkedField",
            "name": "goToPreviousElement",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ContentSubmission",
                "kind": "LinkedField",
                "name": "contentSubmission",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "ContentSubmissionScreen_ContentSubmissionFragment"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ProjectContentElementContainer_GoBackElementWiseMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ELearningMutations",
        "kind": "LinkedField",
        "name": "ELearning",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "GoToPreviousElementPayload",
            "kind": "LinkedField",
            "name": "goToPreviousElement",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ContentSubmission",
                "kind": "LinkedField",
                "name": "contentSubmission",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "LearnOpportunityV2",
                    "kind": "LinkedField",
                    "name": "learnOpportunity",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "LearnOpportunityV2",
                        "kind": "LinkedField",
                        "name": "root",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          (v3/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "structureDefinition",
                            "plural": false,
                            "selections": [
                              (v4/*: any*/),
                              (v5/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Tag",
                                    "kind": "LinkedField",
                                    "name": "tags",
                                    "plural": true,
                                    "selections": [
                                      (v6/*: any*/),
                                      (v2/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "colorHex",
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "File",
                                    "kind": "LinkedField",
                                    "name": "icon",
                                    "plural": false,
                                    "selections": (v8/*: any*/),
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "extension",
                                    "plural": false,
                                    "selections": [
                                      (v4/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "InfectopharmTreeConfigConsequences",
                                            "kind": "LinkedField",
                                            "name": "configConsequences",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "restartTriesCount",
                                                "storageKey": null
                                              },
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "isRewardedTo",
                                                "storageKey": null
                                              },
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "rewardExpired",
                                                "storageKey": null
                                              },
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "showAnswerExpired",
                                                "storageKey": null
                                              }
                                            ],
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "totalUserTries",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "ReducedDataInTree",
                                            "kind": "LinkedField",
                                            "name": "reducedDataInTree",
                                            "plural": false,
                                            "selections": [
                                              (v9/*: any*/),
                                              (v10/*: any*/)
                                            ],
                                            "storageKey": null
                                          },
                                          (v11/*: any*/),
                                          (v12/*: any*/)
                                        ],
                                        "type": "LearnOpportunityRootExtensionImpl",
                                        "abstractKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  (v15/*: any*/)
                                ],
                                "type": "LearnOpportunityRootStructureDefinition",
                                "abstractKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "typeDefinition",
                            "plural": false,
                            "selections": [
                              (v4/*: any*/),
                              (v16/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "contentNodeAdvancementResult",
                                    "plural": false,
                                    "selections": [
                                      (v4/*: any*/),
                                      (v17/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v18/*: any*/),
                                  (v20/*: any*/)
                                ],
                                "type": "LearnOpportunityELearningContentTypeDefinition",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "LearnOpportunityV2",
                                    "kind": "LinkedField",
                                    "name": "children",
                                    "plural": true,
                                    "selections": [
                                      (v2/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": null,
                                        "kind": "LinkedField",
                                        "name": "typeDefinition",
                                        "plural": false,
                                        "selections": [
                                          (v4/*: any*/),
                                          (v16/*: any*/),
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": null,
                                                "kind": "LinkedField",
                                                "name": "contentNodeAdvancementResult",
                                                "plural": false,
                                                "selections": [
                                                  (v4/*: any*/),
                                                  (v17/*: any*/),
                                                  (v21/*: any*/),
                                                  (v22/*: any*/),
                                                  (v23/*: any*/)
                                                ],
                                                "storageKey": null
                                              },
                                              (v18/*: any*/),
                                              (v20/*: any*/)
                                            ],
                                            "type": "LearnOpportunityELearningContentTypeDefinition",
                                            "abstractKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      },
                                      (v3/*: any*/),
                                      (v24/*: any*/),
                                      (v25/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": null,
                                        "kind": "LinkedField",
                                        "name": "attachmentsV2",
                                        "plural": true,
                                        "selections": [
                                          (v4/*: any*/),
                                          {
                                            "kind": "InlineFragment",
                                            "selections": (v27/*: any*/),
                                            "type": "InfectopharmFileAttachment",
                                            "abstractKey": null
                                          },
                                          (v2/*: any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "type": "LearnOpportunityBranchTypeDefinition",
                                "abstractKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v24/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "attachmentsV2",
                            "plural": true,
                            "selections": [
                              (v4/*: any*/),
                              (v2/*: any*/),
                              (v5/*: any*/),
                              (v28/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "File",
                                    "kind": "LinkedField",
                                    "name": "file",
                                    "plural": false,
                                    "selections": [
                                      (v7/*: any*/),
                                      (v2/*: any*/),
                                      (v6/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "fileType",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "accessType",
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "type": "InfectopharmFileAttachment",
                                "abstractKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "structureDefinition",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          (v5/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "extension",
                                "plural": false,
                                "selections": [
                                  (v4/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v11/*: any*/)
                                    ],
                                    "type": "LearnOpportunityRootExtensionImpl",
                                    "abstractKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "LearnOpportunityRootStructureDefinition",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "typeDefinition",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          (v16/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v18/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "extension",
                                "plural": false,
                                "selections": [
                                  (v4/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "lengthInSecondsOverride",
                                        "storageKey": null
                                      },
                                      (v9/*: any*/),
                                      (v10/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "amountOfMultipleChoiceElementsInContentSubmission",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "ContentConfigConsequences",
                                        "kind": "LinkedField",
                                        "name": "configConsequences",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "percentageRequiredToPass",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "isBlockedPermanentlyAfterNumFailedTries",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "isBlockedTemporarilyForNumDaysAfterOneFailedTry",
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      },
                                      (v19/*: any*/)
                                    ],
                                    "type": "LearnContentExtensionImpl",
                                    "abstractKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "contentNodeAdvancementResult",
                                "plural": false,
                                "selections": [
                                  (v4/*: any*/),
                                  (v17/*: any*/),
                                  (v23/*: any*/),
                                  (v21/*: any*/),
                                  (v22/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "LearnOpportunityELearningContentTypeDefinition",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v2/*: any*/),
                      (v28/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "LearnOpportunityV2",
                        "kind": "LinkedField",
                        "name": "nextContentNode",
                        "plural": false,
                        "selections": [
                          (v25/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "typeDefinition",
                            "plural": false,
                            "selections": [
                              (v4/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v18/*: any*/)
                                ],
                                "type": "LearnOpportunityELearningContentTypeDefinition",
                                "abstractKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v2/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v3/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "definition",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      (v17/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v30/*: any*/)
                        ],
                        "type": "FailedELearningContentSubmissionDefinition",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v30/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "rewardResults",
                            "plural": true,
                            "selections": [
                              (v4/*: any*/),
                              (v13/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "rewardKind",
                                "storageKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v31/*: any*/),
                                "type": "PharmaPointsRewardWasPossibleResult",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v31/*: any*/),
                                "type": "PacPointsRewardWasPossibleResult",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v32/*: any*/),
                                "type": "FachberaterWasAwardedResult",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v32/*: any*/),
                                "type": "CertificateRewardWasPossibleResult",
                                "abstractKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "type": "PassedELearningContentSubmissionDefinition",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "canGoToPrevious",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "progress",
                            "plural": false,
                            "selections": [
                              (v4/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "percentage",
                                "storageKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "isAtLastElement",
                                    "storageKey": null
                                  },
                                  (v29/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "currentElementIndex",
                                    "storageKey": null
                                  }
                                ],
                                "type": "ActiveELearningContentSubmissionProgress",
                                "abstractKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "currentElementState",
                            "plural": false,
                            "selections": [
                              (v4/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "element",
                                "plural": false,
                                "selections": [
                                  (v4/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "elementType",
                                    "storageKey": null
                                  },
                                  (v2/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v26/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "fileContentType",
                                        "storageKey": null
                                      },
                                      (v5/*: any*/)
                                    ],
                                    "type": "FileLearnElement",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": null,
                                        "kind": "LinkedField",
                                        "name": "podcastSource",
                                        "plural": false,
                                        "selections": [
                                          (v4/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "sourceType",
                                            "storageKey": null
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "podigeeUrl",
                                                "storageKey": null
                                              }
                                            ],
                                            "type": "PodigeePodcastSourceV2",
                                            "abstractKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "ReleasedFileV2",
                                        "kind": "LinkedField",
                                        "name": "releasedFileOpt",
                                        "plural": false,
                                        "selections": (v27/*: any*/),
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "ReleasedSubtitlesV2",
                                        "kind": "LinkedField",
                                        "name": "releasedSubtitlesOpt",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "SubtitlesV2",
                                            "kind": "LinkedField",
                                            "name": "subtitles",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "SubtitleV2",
                                                "kind": "LinkedField",
                                                "name": "subtitles",
                                                "plural": true,
                                                "selections": [
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "startTime",
                                                    "storageKey": null
                                                  },
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "endTime",
                                                    "storageKey": null
                                                  },
                                                  (v33/*: any*/)
                                                ],
                                                "storageKey": null
                                              }
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      },
                                      (v5/*: any*/)
                                    ],
                                    "type": "PodcastLearnElement",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v33/*: any*/),
                                      (v5/*: any*/)
                                    ],
                                    "type": "TextLearnElement",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "File",
                                        "kind": "LinkedField",
                                        "name": "videoFile",
                                        "plural": false,
                                        "selections": (v8/*: any*/),
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "SubtitlesForLanguage",
                                        "kind": "LinkedField",
                                        "name": "subtitles",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "VideoSubtitle",
                                            "kind": "LinkedField",
                                            "name": "subtitles",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "startTimeInSec",
                                                "storageKey": null
                                              },
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "endTimeInSec",
                                                "storageKey": null
                                              },
                                              (v33/*: any*/)
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      },
                                      (v5/*: any*/)
                                    ],
                                    "type": "VideoLearnElement",
                                    "abstractKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              (v13/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "element",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v34/*: any*/),
                                          (v36/*: any*/),
                                          (v35/*: any*/),
                                          (v37/*: any*/)
                                        ],
                                        "type": "MultipleChoiceLearnElement",
                                        "abstractKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "type": "UntouchedElementState",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "element",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v36/*: any*/),
                                          (v34/*: any*/),
                                          (v35/*: any*/),
                                          (v37/*: any*/)
                                        ],
                                        "type": "MultipleChoiceLearnElement",
                                        "abstractKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "checkedAnswerIndices",
                                    "storageKey": null
                                  }
                                ],
                                "type": "MultipleChoiceInputElementState",
                                "abstractKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "type": "ActiveELearningContentSubmissionDefinition",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "8be3bfbf7afccf46bb6766fff22e9865",
    "id": null,
    "metadata": {},
    "name": "ProjectContentElementContainer_GoBackElementWiseMutation",
    "operationKind": "mutation",
    "text": "mutation ProjectContentElementContainer_GoBackElementWiseMutation(\n  $input: GoToPreviousElementInput!\n) {\n  ELearning {\n    goToPreviousElement(input: $input) {\n      contentSubmission {\n        ...ContentSubmissionScreen_ContentSubmissionFragment\n        id\n      }\n    }\n  }\n}\n\nfragment AttachmentButtonsDisplayFragment_LearnOpportunityV2Fragment on LearnOpportunityV2 {\n  root {\n    id\n    attachmentsV2 {\n      __typename\n      title\n      description\n      ... on InfectopharmFileAttachment {\n        file {\n          id\n          url\n          name\n        }\n      }\n      id\n    }\n  }\n}\n\nfragment AttachmentCard_AttachmentFragment on InfectopharmFileAttachment {\n  id\n  file {\n    name\n    url\n    fileType\n    accessType\n    id\n  }\n  title\n  description\n}\n\nfragment AttachmentDisplay_LearnOpportunityV2Fragment on LearnOpportunityV2 {\n  root {\n    id\n    attachmentsV2 {\n      __typename\n      ... on InfectopharmFileAttachment {\n        ...AttachmentCard_AttachmentFragment\n      }\n      id\n    }\n  }\n}\n\nfragment AttachmentHeftDisplay_LearnOpportunityV2Fragment on LearnOpportunityV2 {\n  id\n  structureDefinition {\n    __typename\n    ... on LearnOpportunityRootStructureDefinition {\n      extension {\n        __typename\n        ... on LearnOpportunityRootExtensionImpl {\n          firstLearnOpportunityIdWithMultipleChoiceElement\n        }\n      }\n    }\n  }\n  root {\n    id\n    structureDefinition {\n      __typename\n      ... on LearnOpportunityRootStructureDefinition {\n        extension {\n          __typename\n          ... on LearnOpportunityRootExtensionImpl {\n            firstLearnOpportunityIdWithMultipleChoiceElement\n          }\n        }\n      }\n    }\n    attachmentsV2 {\n      __typename\n      ... on InfectopharmFileAttachment {\n        file {\n          url\n          id\n        }\n      }\n      id\n    }\n    typeDefinition {\n      __typename\n      ... on LearnOpportunityBranchTypeDefinition {\n        children {\n          id\n          attachmentsV2 {\n            __typename\n            ... on InfectopharmFileAttachment {\n              file {\n                url\n                id\n              }\n            }\n            id\n          }\n        }\n      }\n    }\n  }\n  ...AttachmentButtonsDisplayFragment_LearnOpportunityV2Fragment\n}\n\nfragment ContentElementContainer_ContentSubmissionFragment on ContentSubmission {\n  id\n  definition {\n    __typename\n    ... on ActiveELearningContentSubmissionDefinition {\n      canGoToPrevious\n      progress {\n        __typename\n        percentage\n      }\n    }\n  }\n  learnOpportunity {\n    id\n    ...AttachmentDisplay_LearnOpportunityV2Fragment\n  }\n}\n\nfragment ContentSubmissionScreen_ContentSubmissionFragment on ContentSubmission {\n  id\n  learnOpportunity {\n    ...NodeContainer_LearnOpportunityV2Fragment\n    id\n  }\n  definition {\n    __typename\n    status\n  }\n  ...contentSubmissionEnd_ContentSubmissionFragment\n  ...PaediaContentElement_ContentSubmissionFragment\n}\n\nfragment FailedContentButton_ContentSubmissionFragment on ContentSubmission {\n  id\n  definition {\n    __typename\n    status\n  }\n  learnOpportunity {\n    root {\n      id\n    }\n    id\n    typeDefinition {\n      __typename\n      ... on LearnOpportunityELearningContentTypeDefinition {\n        extension {\n          __typename\n          ... on LearnContentExtensionImpl {\n            configConsequences {\n              isBlockedPermanentlyAfterNumFailedTries\n            }\n          }\n        }\n        contentNodeAdvancementResult {\n          __typename\n          status\n          ... on CanNotBeRestartedAfterFailedContentNodeAdvancementResult {\n            configResults {\n              __typename\n              configType\n              __isRestartIfFailedContentConfigResult: __typename\n              canBeRestarted\n              ... on NegativeBlockPermanentlyRestartIfFailedContentConfigResult {\n                canBeRestarted\n              }\n              ... on NegativeBlockTemporarilyRestartIfFailedContentConfigResult {\n                blockedUntil\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment FileElementDisplay_FileElementV2Fragment on FileLearnElement {\n  file {\n    url\n    id\n  }\n  fileContentType\n  title\n}\n\nfragment FileElementPart_ContentSubmissionFragment on ContentSubmission {\n  id\n  definition {\n    __typename\n    ... on ActiveELearningContentSubmissionDefinition {\n      currentElementState {\n        __typename\n        element {\n          __typename\n          ...FileElementDisplay_FileElementV2Fragment\n          id\n        }\n      }\n    }\n  }\n  ...ProjectContentElementContainer_ContentSubmissionFragment\n  ...SubmitDisplayElementButton_ContentSubmissionFragment\n}\n\nfragment MultipleChoiceElementDisplay_MultipleChoiceElementV2Fragment on MultipleChoiceLearnElement {\n  question\n  image {\n    url\n    id\n  }\n  answeringType\n  answerOptions {\n    answer\n    image {\n      url\n      id\n    }\n  }\n}\n\nfragment NavigateDirectToQuestionsAdvanceContentButton_LearnOpportunityFragment on LearnOpportunityV2 {\n  id\n  root {\n    structureDefinition {\n      __typename\n      ... on LearnOpportunityRootStructureDefinition {\n        extension {\n          __typename\n          ... on LearnOpportunityRootExtensionImpl {\n            wordpressCertificates {\n              id\n            }\n          }\n        }\n      }\n    }\n    id\n  }\n  shortDescription\n  structureDefinition {\n    __typename\n    title\n  }\n  typeDefinition {\n    __typename\n    ... on LearnOpportunityELearningContentTypeDefinition {\n      definitionType\n      contentNodeAdvancementResult {\n        __typename\n        status\n        ... on CanNotBeStartedContentNodeAdvancementResult {\n          reasonConfigTypes\n        }\n        ... on ContinueContentNodeAdvancementResult {\n          activeContentSubmissionId\n        }\n        ... on CanNotBeRestartedAfterFailedContentNodeAdvancementResult {\n          status\n          configResults {\n            __typename\n            configType\n            __isRestartIfFailedContentConfigResult: __typename\n            canBeRestarted\n            ... on NegativeBlockPermanentlyRestartIfFailedContentConfigResult {\n              canBeRestarted\n            }\n            ... on NegativeBlockTemporarilyRestartIfFailedContentConfigResult {\n              blockedUntil\n            }\n          }\n        }\n      }\n      containedElementTypes\n    }\n  }\n}\n\nfragment NavigateDirectToQuestionsAdvanceTreeButton_LearnOpportunityV2Fragment on LearnOpportunityV2 {\n  id\n  shortDescription\n  root {\n    id\n    structureDefinition {\n      __typename\n      title\n      ... on LearnOpportunityRootStructureDefinition {\n        extension {\n          __typename\n          ... on LearnOpportunityRootExtensionImpl {\n            wordpressCertificates {\n              id\n            }\n          }\n        }\n        viewerTreeState {\n          __typename\n          kind\n          ... on CanNotBeStartedViewerTreeState {\n            reasonConfigTypes\n          }\n          ... on IsStartedViewerTreeState {\n            headContentId\n          }\n        }\n      }\n    }\n  }\n  structureDefinition {\n    __typename\n    title\n  }\n  typeDefinition {\n    __typename\n    definitionType\n    ... on LearnOpportunityELearningContentTypeDefinition {\n      containedElementTypes\n      contentNodeAdvancementResult {\n        __typename\n        status\n      }\n      extension {\n        __typename\n        ... on LearnContentExtensionImpl {\n          pacPoints\n          pharmaPoints\n          headFirstElementType\n        }\n      }\n    }\n  }\n}\n\nfragment NodeConfigurationsDisplay_NodeFragment on LearnOpportunityV2 {\n  root {\n    structureDefinition {\n      __typename\n      ... on LearnOpportunityRootStructureDefinition {\n        extension {\n          __typename\n          ... on LearnOpportunityRootExtensionImpl {\n            configConsequences {\n              rewardExpired\n            }\n          }\n        }\n      }\n    }\n    id\n  }\n  typeDefinition {\n    __typename\n    definitionType\n    ... on LearnOpportunityELearningContentTypeDefinition {\n      extension {\n        __typename\n        ... on LearnContentExtensionImpl {\n          amountOfMultipleChoiceElementsInContentSubmission\n          configConsequences {\n            percentageRequiredToPass\n            isBlockedPermanentlyAfterNumFailedTries\n            isBlockedTemporarilyForNumDaysAfterOneFailedTry\n          }\n        }\n      }\n      containedElementTypes\n    }\n  }\n}\n\nfragment NodeContainer_LearnOpportunityV2Fragment on LearnOpportunityV2 {\n  root {\n    ...NodeContentElementsList_NodeFragment\n    id\n    typeDefinition {\n      __typename\n      definitionType\n      ... on LearnOpportunityELearningContentTypeDefinition {\n        containedElementTypes\n      }\n      ... on LearnOpportunityBranchTypeDefinition {\n        children {\n          ...ProjectContentButtonCME_LearnOpportunityFragment\n          id\n          shortDescription\n          structureDefinition {\n            __typename\n            title\n          }\n          typeDefinition {\n            __typename\n            definitionType\n            ... on LearnOpportunityELearningContentTypeDefinition {\n              containedElementTypes\n              contentNodeAdvancementResult {\n                __typename\n                status\n                ... on CanNotBeStartedContentNodeAdvancementResult {\n                  reasonConfigTypes\n                }\n                ... on ContinueContentNodeAdvancementResult {\n                  activeContentSubmissionId\n                }\n                ... on CanNotBeRestartedAfterFailedContentNodeAdvancementResult {\n                  configResults {\n                    __typename\n                    configType\n                    ... on NegativeBlockPermanentlyRestartIfFailedContentConfigResult {\n                      canBeRestarted\n                    }\n                    ... on NegativeBlockTemporarilyRestartIfFailedContentConfigResult {\n                      blockedUntil\n                    }\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n    structureDefinition {\n      __typename\n      title\n      ... on LearnOpportunityRootStructureDefinition {\n        tags {\n          name\n          id\n        }\n        icon {\n          url\n          id\n        }\n        extension {\n          __typename\n          ... on LearnOpportunityRootExtensionImpl {\n            configConsequences {\n              restartTriesCount\n              isRewardedTo\n              rewardExpired\n              showAnswerExpired\n            }\n            totalUserTries\n            reducedDataInTree {\n              pacPoints\n              pharmaPoints\n            }\n          }\n        }\n        ...NodeTagList_LearnOpportunityRootStructureDefinitionFragment\n      }\n    }\n  }\n  structureDefinition {\n    __typename\n    title\n  }\n  typeDefinition {\n    __typename\n    ... on LearnOpportunityELearningContentTypeDefinition {\n      containedElementTypes\n      extension {\n        __typename\n        ... on LearnContentExtensionImpl {\n          lengthInSecondsOverride\n          pacPoints\n          pharmaPoints\n        }\n      }\n    }\n  }\n  ...NodeTopBar_LearnOpportunityV2Fragment\n  ...NodeConfigurationsDisplay_NodeFragment\n  ...NodeDescription_NodeFragment\n  ...AttachmentHeftDisplay_LearnOpportunityV2Fragment\n}\n\nfragment NodeContentElementsList_NodeFragment on LearnOpportunityV2 {\n  id\n  shortDescription\n  structureDefinition {\n    __typename\n    title\n  }\n  ...ProjectContentButtonCME_LearnOpportunityFragment\n  typeDefinition {\n    __typename\n    definitionType\n    ... on LearnOpportunityELearningContentTypeDefinition {\n      containedElementTypes\n    }\n    ... on LearnOpportunityBranchTypeDefinition {\n      children {\n        ...ProjectContentButtonCME_LearnOpportunityFragment\n        id\n        shortDescription\n        structureDefinition {\n          __typename\n          title\n        }\n        typeDefinition {\n          __typename\n          definitionType\n          ... on LearnOpportunityELearningContentTypeDefinition {\n            containedElementTypes\n            contentNodeAdvancementResult {\n              __typename\n              status\n              ... on CanNotBeStartedContentNodeAdvancementResult {\n                reasonConfigTypes\n              }\n              ... on ContinueContentNodeAdvancementResult {\n                activeContentSubmissionId\n              }\n              ... on CanNotBeRestartedAfterFailedContentNodeAdvancementResult {\n                configResults {\n                  __typename\n                  configType\n                  __isRestartIfFailedContentConfigResult: __typename\n                  canBeRestarted\n                  ... on NegativeBlockPermanentlyRestartIfFailedContentConfigResult {\n                    canBeRestarted\n                  }\n                  ... on NegativeBlockTemporarilyRestartIfFailedContentConfigResult {\n                    blockedUntil\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment NodeDescription_NodeFragment on LearnOpportunityV2 {\n  description\n}\n\nfragment NodeTagList_LearnOpportunityRootStructureDefinitionFragment on LearnOpportunityRootStructureDefinition {\n  tags {\n    id\n    ...NodeTag_TagFragment\n  }\n}\n\nfragment NodeTag_TagFragment on Tag {\n  id\n  name\n  colorHex\n}\n\nfragment NodeTopBar_LearnOpportunityV2Fragment on LearnOpportunityV2 {\n  id\n}\n\nfragment PaediaContentElement_ContentSubmissionFragment on ContentSubmission {\n  definition {\n    __typename\n    ... on ActiveELearningContentSubmissionDefinition {\n      currentElementState {\n        __typename\n        element {\n          __typename\n          elementType\n          id\n        }\n      }\n    }\n  }\n  ...FileElementPart_ContentSubmissionFragment\n  ...PaediaMultipleChoiceElementPart_ContentSubmissionFragment\n  ...PodcastElementPart_ContentSubmissionFragment\n  ...TextElementPart_ContentSubmissionFragment\n  ...VideoElementPart_ContentSubmissionFragment\n}\n\nfragment PaediaMultipleChoiceElementPart_ContentSubmissionFragment on ContentSubmission {\n  id\n  learnOpportunity {\n    id\n  }\n  definition {\n    __typename\n    ... on ActiveELearningContentSubmissionDefinition {\n      progress {\n        __typename\n        percentage\n        ... on ActiveELearningContentSubmissionProgress {\n          isAtLastElement\n          numElements\n          currentElementIndex\n        }\n      }\n      currentElementState {\n        __typename\n        kind\n        ... on UntouchedElementState {\n          element {\n            __typename\n            id\n            ... on MultipleChoiceLearnElement {\n              question\n              answerOptions {\n                answer\n              }\n              ...MultipleChoiceElementDisplay_MultipleChoiceElementV2Fragment\n            }\n          }\n        }\n        ... on MultipleChoiceInputElementState {\n          element {\n            __typename\n            id\n            ... on MultipleChoiceLearnElement {\n              answerOptions {\n                answer\n              }\n              ...MultipleChoiceElementDisplay_MultipleChoiceElementV2Fragment\n            }\n          }\n          checkedAnswerIndices\n        }\n      }\n    }\n  }\n  ...ProjectContentElementContainer_ContentSubmissionFragment\n}\n\nfragment PodcastElementDisplay_PodcastElementV2Fragment on PodcastLearnElement {\n  podcastSource {\n    __typename\n    sourceType\n    ... on PodigeePodcastSourceV2 {\n      podigeeUrl\n    }\n  }\n  releasedFileOpt {\n    file {\n      url\n      id\n    }\n  }\n  releasedSubtitlesOpt {\n    subtitles {\n      subtitles {\n        startTime\n        endTime\n        text\n      }\n    }\n  }\n  title\n}\n\nfragment PodcastElementPart_ContentSubmissionFragment on ContentSubmission {\n  id\n  definition {\n    __typename\n    ... on ActiveELearningContentSubmissionDefinition {\n      currentElementState {\n        __typename\n        element {\n          __typename\n          ...PodcastElementDisplay_PodcastElementV2Fragment\n          id\n        }\n      }\n    }\n  }\n  ...ContentElementContainer_ContentSubmissionFragment\n  ...SubmitDisplayElementButton_ContentSubmissionFragment\n  ...ProjectContentElementContainer_ContentSubmissionFragment\n}\n\nfragment ProjectContentButtonCME_LearnOpportunityFragment on LearnOpportunityV2 {\n  id\n  typeDefinition {\n    __typename\n    definitionType\n    ... on LearnOpportunityELearningContentTypeDefinition {\n      contentNodeAdvancementResult {\n        __typename\n        status\n      }\n    }\n  }\n  ...NavigateDirectToQuestionsAdvanceTreeButton_LearnOpportunityV2Fragment\n}\n\nfragment ProjectContentElementContainer_ContentSubmissionFragment on ContentSubmission {\n  id\n  definition {\n    __typename\n    ... on ActiveELearningContentSubmissionDefinition {\n      canGoToPrevious\n      progress {\n        __typename\n        percentage\n      }\n    }\n  }\n  learnOpportunity {\n    id\n    root {\n      id\n    }\n    typeDefinition {\n      __typename\n      ... on LearnOpportunityELearningContentTypeDefinition {\n        containedElementTypes\n      }\n    }\n    ...AttachmentDisplay_LearnOpportunityV2Fragment\n  }\n}\n\nfragment SubmitDisplayElementButton_ContentSubmissionFragment on ContentSubmission {\n  id\n  definition {\n    __typename\n    ... on ActiveELearningContentSubmissionDefinition {\n      currentElementState {\n        __typename\n        element {\n          __typename\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment TextElementDisplay_TextElementV2Fragment on TextLearnElement {\n  text\n  title\n}\n\nfragment TextElementPart_ContentSubmissionFragment on ContentSubmission {\n  id\n  definition {\n    __typename\n    ... on ActiveELearningContentSubmissionDefinition {\n      currentElementState {\n        __typename\n        element {\n          __typename\n          ...TextElementDisplay_TextElementV2Fragment\n          id\n        }\n      }\n    }\n  }\n  ...ContentElementContainer_ContentSubmissionFragment\n  ...SubmitDisplayElementButton_ContentSubmissionFragment\n  ...ProjectContentElementContainer_ContentSubmissionFragment\n}\n\nfragment VideoElementDisplay_VideoLearnElementFragment on VideoLearnElement {\n  videoFile {\n    url\n    id\n  }\n  subtitles {\n    subtitles {\n      startTimeInSec\n      endTimeInSec\n      text\n    }\n  }\n  title\n}\n\nfragment VideoElementPart_ContentSubmissionFragment on ContentSubmission {\n  id\n  definition {\n    __typename\n    ... on ActiveELearningContentSubmissionDefinition {\n      currentElementState {\n        __typename\n        element {\n          __typename\n          ...VideoElementDisplay_VideoLearnElementFragment\n          id\n        }\n      }\n    }\n  }\n  ...ContentElementContainer_ContentSubmissionFragment\n  ...SubmitDisplayElementButton_ContentSubmissionFragment\n  ...ProjectContentElementContainer_ContentSubmissionFragment\n}\n\nfragment contentSubmissionEnd_ContentSubmissionFragment on ContentSubmission {\n  id\n  learnOpportunity {\n    id\n    nextContentNode {\n      structureDefinition {\n        __typename\n        title\n      }\n      typeDefinition {\n        __typename\n        ... on LearnOpportunityELearningContentTypeDefinition {\n          containedElementTypes\n        }\n      }\n      id\n    }\n    root {\n      structureDefinition {\n        __typename\n        title\n        ... on LearnOpportunityRootStructureDefinition {\n          tags {\n            name\n            id\n          }\n          extension {\n            __typename\n            ... on LearnOpportunityRootExtensionImpl {\n              configConsequences {\n                rewardExpired\n                showAnswerExpired\n              }\n            }\n          }\n        }\n      }\n      id\n    }\n    typeDefinition {\n      __typename\n      ... on LearnOpportunityELearningContentTypeDefinition {\n        containedElementTypes\n        contentNodeAdvancementResult {\n          __typename\n          status\n          ... on CanNotBeRestartedAfterFailedContentNodeAdvancementResult {\n            configResults {\n              __typename\n              configType\n              __isRestartIfFailedContentConfigResult: __typename\n              canBeRestarted\n              ... on NegativeBlockPermanentlyRestartIfFailedContentConfigResult {\n                canBeRestarted\n              }\n              ... on NegativeBlockTemporarilyRestartIfFailedContentConfigResult {\n                blockedUntil\n              }\n            }\n          }\n        }\n      }\n    }\n    ...NavigateDirectToQuestionsAdvanceTreeButton_LearnOpportunityV2Fragment\n    ...NavigateDirectToQuestionsAdvanceContentButton_LearnOpportunityFragment\n  }\n  definition {\n    __typename\n    status\n    ... on FailedELearningContentSubmissionDefinition {\n      relativeProgress {\n        numCorrect\n        numElements\n        percentageCorrect\n      }\n    }\n    ... on PassedELearningContentSubmissionDefinition {\n      relativeProgress {\n        numCorrect\n        numElements\n        percentageCorrect\n      }\n      rewardResults {\n        __typename\n        kind\n        rewardKind\n        ... on PharmaPointsRewardWasPossibleResult {\n          amount\n        }\n        ... on PacPointsRewardWasPossibleResult {\n          amount\n        }\n        ... on FachberaterWasAwardedResult {\n          certificateName\n          issuedCertificate {\n            fileRef {\n              url\n              id\n            }\n          }\n        }\n        ... on CertificateRewardWasPossibleResult {\n          certificateName\n          issuedCertificate {\n            fileRef {\n              url\n              id\n            }\n          }\n        }\n      }\n    }\n  }\n  ...ContentElementContainer_ContentSubmissionFragment\n  ...FailedContentButton_ContentSubmissionFragment\n  ...ProjectContentElementContainer_ContentSubmissionFragment\n  ...moduleRating_ContentSubmissionFragment\n}\n\nfragment moduleRating_ContentSubmissionFragment on ContentSubmission {\n  learnOpportunity {\n    root {\n      id\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "254a16e20b72fa59ab72bf2e3a29d394";

export default node;
